<template>
    <div class="demoEnterprise">
        <!-- 查询或新增列表 -->
        <el-form :inline="true" :model="enterpriseQuery">
            <el-form-item>
                <el-input
                    v-model="enterpriseQuery.title"
                    placeholder="请输入企业名称"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getEnterpriseList(1)">查询</el-button>
                <el-button @click="addOrUpdateHandle()"
                    >新增</el-button
                >
                <el-button type="warning" @click="chongzhi">重置</el-button>
            </el-form-item>
        </el-form>
        <!-- 列表展示 -->
        <el-table
            :data="enterpriseList"
            style="width: 100%"
            border
            v-loading="loading"
        >
            <el-table-column type="index" width="50" label="#" align="center"> </el-table-column>    
            <el-table-column
                prop="title"
                label="企业名称"
                width="180"
                align="center"
                show-overflow-tooltip
            >
            <template slot-scope="scope">
                    <span v-html="showcontent(scope.row.title)"></span>
                </template>
            </el-table-column>
            <!-- <el-table-column
                prop="address"
                label="企业地址"
                width="150"
                align="center"
                show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                prop="website"
                label="企业网站"
                width="150"
                align="center"
                show-overflow-tooltip
            >
            </el-table-column> -->
            <el-table-column label="企业logo" align="center" width="150">
                <template slot-scope="scope">
                    <div class="img-show">
                        <el-image
                            v-if="scope.row.thumb != null"
                            width="75%"
                            contain
                            class="image-slot"
                            :src="scope.row.thumb"
                            :preview-src-list="[scope.row.thumb]"
                            fit="contain"
                        ></el-image>
                        <div v-else slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="企业描述"
                width="200"
                align="center"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <span v-html="showcontent(scope.row.description)"></span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="示范企业类型" width="150">
                <template slot-scope="scope">
                    <span>
                        {{
                            scope.row.type === "0"
                                ? "数字商务企业"
                                : scope.row.type === "1"
                                ? "国家级电商示范企业"
                                : "省级电商示范企业"
                        }}
                    </span>
                </template>
            </el-table-column>
            <!-- <el-table-column
                prop="annual"
                label="年度"
                width="100"
                align="center"
                show-overflow-tooltip
            >
            </el-table-column> -->
            <el-table-column
                prop="cityCode"
                label="城市地区"
                align="center"
                width="90"
            >
                <template slot-scope="scope">
                    <span>{{ codeListObj[scope.row.cityCode] }}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column
                prop="concatPeople"
                align="center"
                label="联系人"
                width="100"
                show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                prop="mobile"
                align="center"
                label="手机"
                width="140"
            >
            </el-table-column>
            <el-table-column
                prop="phone"
                align="center"
                label="电话"
                width="140"
            >
            </el-table-column>

            <el-table-column
                prop="email"
                label="邮箱"
                width="130"
                align="center"
                show-overflow-tooltip
            >
            </el-table-column> -->
            <!-- <el-table-column label="更多" align="center" width="80">
                <template slot-scope="scope">
                    <el-popover placement="right" width="400" trigger="click">
                    <el-form
              label-position="left"
              inline
              class="demo-table-expand"
              label-width="100px"
            >
              <el-form-item label="企业网站">
                <span v-html="showcontent(scope.row.website)"></span>
              </el-form-item>
              <el-form-item label="邮箱">
                <span>{{ scope.row.email }}</span>
              </el-form-item>
              <el-form-item label="电话">
                <span>{{ scope.row.phone }}</span>
              </el-form-item>
              <el-form-item label="手机">
                <span>{{ scope.row.mobile }}</span>
              </el-form-item>
              <el-form-item label="地址">
                <span>{{ scope.row.address }}</span>
              </el-form-item>
              <el-form-item label="年度">
                <span>{{ scope.row.annual }}</span>
              </el-form-item>
              <el-form-item label="联系人">
                <span>{{ scope.row.concatPeople }}</span>
              </el-form-item>
            </el-form> -->

            <!-- <el-link class="overflow" :underline="false" slot="reference"> -->
             <!-- <el-button slot="reference">更多</el-button> -->
            <!-- </el-link> -->
                    <!-- </el-popover>
                </template>
            </el-table-column> -->
            <!-- <el-table-column label="内容" align="center" width="120">
                <template slot-scope="scope">
                    <el-popover placement="right" width="400" trigger="click">
                        <span v-html="showcontent(scope.row.content)"></span>
                        <el-button slot="reference">内容详情</el-button>
                    </el-popover>
                </template>
            </el-table-column> -->
            <el-table-column prop="sort" label="排序" align="center" width="70">
                <template slot-scope="scope">
                    <el-input
                    class="e-input"
                        v-model.number="scope.row.sort"
                        @blur="updateSort(scope.row)"
                    ></el-input>
                </template>
            </el-table-column>
            <el-table-column
                prop="checkStatus"
                label="审核状态"
                align="center"
                width="120"
            >
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        plain
                        class="padding-style"
                        :type="checkStyle(scope.row.checkStatus + '')"
                        disable-transitions
                        @click="examineStatus(scope.row)"
                    >
                        <!-- :disabled="scope.row.checkStatus === 0" -->
                        {{ checkShow(scope.row.checkStatus + "") }}
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column
                prop="showStatus"
                label="状态"
                align="center"
                width="100"
            >
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        plain
                        class="padding-style"
                        :type="
                            scope.row.showStatus === '0' ? 'danger' : 'success'
                        "
                        @click="changeShow(scope.row)"
                        :disabled="scope.row.checkStatus === '0'"
                    >
                        {{ scope.row.showStatus === "0" ? "不显示" : "显示" }}
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="160" align="center">
                <template slot-scope="scope">
                    <el-button
                        type="text"
                        size="mini"
                        @click="addOrUpdateHandle(scope.row.id)"
                    >
                        修改
                    </el-button>
                    <el-button
                        type="text"
                        size="mini"
                        @click="deleteEnterprise(scope.row.id)"
                    >
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 企业列表分页器 -->
        <el-pagination
            background
            layout="total,prev, pager, next"
            :total="enterpriseTotal"
            @current-change="pageChange"
            :page-size="enterpriseQuery.limit"
            :current-page="enterpriseQuery.page"
        >
        </el-pagination>
        <!-- 审核新添加列表的弹框 -->
        <check-status
            :check-query="checkQuery"
            ref="checkRef"
            @updateComputed="getEnterpriseList"
        />
        <!-- 新增或修改企业对话框 -->
        <enterprise-add-or-update
            ref="enterpriseRef"
            @enterpriseUpdated="getEnterpriseList"
        />
    </div>
</template>

<script>
import { checkMixin } from "@/utils/mixin.js";
import CheckStatus from "@/views/modules/config/child-components/check-status";
import EnterpriseAddOrUpdate from "@/views/modules/config/child-components/enterprise-add-or-update.vue";
import getCityCode from "@/utils/cityCode.js";
import { showcontent } from "@/utils/method.js";

export default {
    mixins: [checkMixin],
    components: {
        CheckStatus,
        EnterpriseAddOrUpdate,
    },
    data() {
        return {
            // 示范企业参数
            enterpriseQuery: {
                limit: 10,
                page: 1,
                title: "",
            },
            // 示范企业列表
            enterpriseList: [],
            // 所有企业
            enterpriseTotal: 0,
            // 审核状态参数
            checkQuery: {
                id: null,
                checkStatus: 1,
            },
            // 城市编码对象列表
            codeListObj: [],
            loading: false,
        };
    },
    created() {
        this.getEnterpriseList();
        getCityCode().then((data) => {
            this.codeListObj = data[0];
        });
    },
    methods: {
        chongzhi(){
             this.enterpriseQuery.title = ""
             this.$nextTick(()=>{
                this.getEnterpriseList()
             })
        },
        showcontent,
        // 获取示范企业列表
        getEnterpriseList(id) {
            id == 1 ? this.enterpriseQuery.page = 1 : ''
            this.loading = true;
            this.$ajaxPost("/demoEnterprise/list", this.enterpriseQuery).then(
                ({ data }) => {
                    if (data.code === 0) {
                        this.enterpriseList = data.data.list;
                        // this.enterpriseList = this.enterpriseList.map(
                        //     (item) => {

                        //     }
                        // );
                        this.enterpriseTotal = data.data.totalCount;
                        this.loading = false;
                    }
                }
            );
        },
        // 分页器改变触发事件
        pageChange(val) {
            this.enterpriseQuery.page = val;
            this.getEnterpriseList();
        },
        // 审核企业状态
        examineStatus(item) {
            const { id, checkStatus } = item;
            this.checkQuery.id = parseInt(id);
            this.checkQuery.checkStatus = checkStatus.toString();
            this.$nextTick(() => {
                this.$refs.checkRef.init("/demoEnterprise/update");
            });
        },
        // 显示/不显示切换按钮
        async changeShow(item) {
            let { id, showStatus } = item;
            showStatus = showStatus === "1" ? "0" : "1";
            const { data } = await this.updateState({ id, showStatus });
            if (data.code === 0) {
             showStatus = item.showStatus;
            }
        },
        // 更新状态
        updateState(queryInfo) {
            return this.$ajaxPost("/demoEnterprise/update", queryInfo);
        },
        // 更新排序保存
        updateSort(item) {
            const { id, sort } = item;
            this.$ajaxPost("/demoEnterprise/update", {
                id: parseInt(id),
                sort,
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.$message.success("排序更新成功");
                    this.getEnterpriseList()
                }
            });
        },
        // 新增/修改示范企业
        addOrUpdateHandle(id) {
            this.$nextTick(() => {
                this.$refs.enterpriseRef.init(id);
            });
        },
        // 删除单个企业信息
        deleteEnterprise(id) {
            this.$confirm("此操作将永久删除该条目,是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$ajaxGet("/demoEnterprise/delete", { id }).then(
                        ({ data }) => {
                            if (data.code === 0) {
                                this.getEnterpriseList();
                                this.$message({
                                    type: "success",
                                    message: "删除成功",
                                });
                            }
                        }
                    );
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
    },
};
</script>

<style lang="less" scoped>
.e-input{
    /deep/.el-input__inner{
        text-align: center;
    }
}
/deep/.el-icon-circle-close{
  color:white
}
</style>